module.exports = __webpack_public_path__ + "assets/img/School.b60a8951.png";